export enum OrderStatusEnum {
    new_order,
    paid,
    cancel,
    finished,
    error,
    in_preparation,
    ready,
    in_transport,
}   